var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon2, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalcasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 225.96,
    height: 42.04,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.96 42.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.01,
    y1: 1031.98,
    x2: 33.18,
    y2: 1031.98,
    gradientTransform: "translate(.04 -1014.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaad44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#bcbe4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ccce50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d6d753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9da55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 7.51,
    y1: 1031.97,
    x2: 38.19,
    y2: 1031.97,
    gradientTransform: "translate(.04 -1014.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1b8fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2da5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3ab5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#41bfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44c2cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.04,
    y1: 1035.74,
    x2: 42.64,
    y2: 1035.74,
    gradientTransform: "translate(.04 -1014.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1b8fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2da5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3ab5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#41bfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44c2cf"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.41,15.96c-.41-2.14-2.37-3.62-4.53-3.43-3.84,0-5.47,3.16-5.47,6.54,0,3.69,1.62,6.75,5.49,6.75,2.52.05,4.61-1.94,4.66-4.46,0-.06,0-.11,0-.17h2.15c-.05,3.63-3.03,6.52-6.66,6.47-.13,0-.27,0-.4-.02-5.01,0-7.46-3.7-7.46-8.4s2.67-8.47,7.64-8.47c3.38,0,6.14,1.81,6.65,5.24l-2.08-.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m72.45,21.19c-1.1.47-2.28.74-3.47.79-1.27.23-2.36.68-2.36,2.1s1.09,1.71,2.26,1.71c2.54,0,3.57-1.58,3.57-2.64v-1.96Zm3.12,5.99c-.43.23-.92.34-1.41.31-.99,0-1.62-.54-1.62-1.81-1.02,1.2-2.54,1.86-4.11,1.81-2.13,0-3.87-.95-3.87-3.28,0-2.64,1.96-3.21,3.95-3.59s3.94-.27,3.94-1.72c0-1.67-1.41-1.93-2.6-1.93-1.64,0-2.82.49-2.92,2.2h-1.93c.11-2.9,2.36-3.9,4.96-3.9,2.1,0,4.38.47,4.38,3.21v6.02c0,.9,0,1.3.61,1.3.2,0,.41-.04.59-.11v1.5h.04Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "77 11.1 78.92 11.1 78.92 27.24 77 27.24 77 11.1 77 11.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.95,15.54h1.92v11.68h-1.92v-11.68Zm1.92-2.1h-1.92v-2.33h1.92v2.36-.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.29,17.26h-1.96v-1.72h1.96v-1.72c0-1.89,1.13-2.82,3.23-2.82.42,0,.84.06,1.24.17v1.62c-.35-.11-.72-.16-1.09-.16-.93,0-1.41.28-1.41,1.3v1.61h2.15v1.69h-2.26v9.99h-1.86v-9.96Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.06,25.82c2.02,0,3.64-1.58,3.64-4.41s-1.6-4.46-3.64-4.46-3.63,1.58-3.63,4.42,1.65,4.45,3.63,4.45Zm0-10.52c3.71,0,5.65,2.68,5.65,6.12s-1.96,6.1-5.65,6.1-5.65-2.68-5.65-6.1,1.96-6.12,5.65-6.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.99,15.54h1.81v2.46h0c.66-1.74,2.38-2.85,4.24-2.73v2.03c-3.09,0-4.24,1.75-4.24,4.72v5.2h-1.81v-11.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.63,15.54h1.81v1.85h0c.75-1.38,2.23-2.21,3.8-2.12,3.08,0,4.03,1.75,4.03,4.24v7.68h-1.88v-7.91c.08-1.21-.83-2.25-2.03-2.33-.11,0-.23,0-.34,0-1.81-.11-3.36,1.26-3.48,3.06-.01.2,0,.4.02.59v6.6h-1.92v-11.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.41,15.54h1.91v11.68h-1.91v-11.68Zm1.91-2.08h-1.91v-2.36h1.91v2.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.69,21.19c-1.11.47-2.29.74-3.49.79-1.26.23-2.34.68-2.34,2.1s1.09,1.71,2.26,1.71c2.53,0,3.57-1.58,3.57-2.64,0,0,0-1.96,0-1.96Zm3.12,5.99c-.43.23-.92.34-1.41.31-1,0-1.62-.54-1.62-1.81-1.03,1.2-2.55,1.86-4.12,1.81-2.12,0-3.86-.95-3.86-3.28,0-2.64,1.96-3.21,3.95-3.59s3.93-.27,3.93-1.72c0-1.67-1.41-1.93-2.6-1.93-1.62,0-2.82.49-2.91,2.2h-1.89c.11-2.9,2.34-3.9,4.94-3.9,2.1,0,4.39.47,4.39,3.21v6.02c0,.9,0,1.3.61,1.3.2,0,.4-.04.59-.11v1.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m155.19,15.96c-.4-2.13-2.36-3.61-4.52-3.43-3.84,0-5.48,3.16-5.48,6.54,0,3.69,1.64,6.75,5.49,6.75,2.52.08,4.62-1.9,4.7-4.42,0-.07,0-.14,0-.21h2.15c-.05,3.62-3.02,6.51-6.64,6.47-.11,0-.23,0-.34-.01-5.03,0-7.47-3.7-7.47-8.4s2.67-8.47,7.64-8.47c3.38,0,6.16,1.81,6.65,5.24l-2.19-.04Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m166.25,21.19c-1.11.47-2.29.74-3.49.79-1.27.23-2.34.68-2.34,2.1s1.07,1.71,2.26,1.71c2.53,0,3.57-1.58,3.57-2.64,0,0,0-1.96,0-1.96Zm3.11,5.99c-.43.23-.92.34-1.41.31-1,0-1.64-.54-1.64-1.81-1.02,1.2-2.54,1.86-4.11,1.81-2.12,0-3.87-.95-3.87-3.28,0-2.64,1.98-3.21,3.97-3.59s3.93-.27,3.93-1.72c0-1.67-1.41-1.93-2.6-1.93-1.62,0-2.82.49-2.91,2.2h-1.92c.1-2.9,2.34-3.9,4.94-3.9,2.1,0,4.39.47,4.39,3.21v6.02c0,.9,0,1.3.61,1.3.2,0,.4-.03.58-.11v1.5h.04Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.89,23.56c0,1.72,1.55,2.26,3.14,2.26,1.2,0,2.82-.27,2.82-1.74s-1.89-1.74-3.81-2.16-3.83-1.07-3.83-3.3,2.33-3.32,4.36-3.32c2.58,0,4.63.81,4.79,3.66h-1.92c-.13-1.5-1.41-1.96-2.71-1.96s-2.49.31-2.49,1.48c0,1.41,2.03,1.61,3.83,2.03s3.81,1.06,3.81,3.33c0,2.82-2.6,3.67-4.97,3.67-2.63,0-4.83-1.06-4.94-3.95h1.92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.95,27.24h-1.81v-1.82h0c-.75,1.38-2.23,2.21-3.8,2.12-3.06,0-4.01-1.75-4.01-4.24v-7.77h1.92v7.91c-.09,1.21.81,2.26,2.02,2.35.12,0,.24,0,.35,0,1.81.11,3.36-1.26,3.48-3.06.01-.2,0-.4-.02-.59v-6.6h1.92v11.68l-.06.03Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m200.37,21.19c-1.1.47-2.28.74-3.47.79-1.27.23-2.36.68-2.36,2.1s1.09,1.71,2.26,1.71c2.53,0,3.57-1.58,3.57-2.64v-1.96Zm3.12,5.99c-.43.23-.92.34-1.41.31-.99,0-1.62-.54-1.62-1.81-1.02,1.21-2.53,1.88-4.11,1.84-2.13,0-3.87-.95-3.87-3.28,0-2.64,1.96-3.21,3.95-3.59s3.94-.27,3.94-1.72c0-1.67-1.41-1.93-2.61-1.93-1.62,0-2.82.49-2.91,2.2h-1.89c.11-2.9,2.36-3.9,4.96-3.9,2.09,0,4.38.47,4.38,3.21v6.02c0,.9,0,1.3.61,1.3.2,0,.41-.04.59-.11v1.5-.03Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "205.03 11.1 206.95 11.1 206.95 27.24 205.03 27.24 205.03 11.1 205.03 11.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m223.97,15.54l-3.28,9.56h0l-3.46-9.56h-5v-3.47h-1.92v3.47h-1.99v1.69h1.99v7.43c0,2.15.79,2.56,2.82,2.56h1.41v-1.69h-.88c-1.2,0-1.41-.16-1.41-1.03v-7.23h3.5l3.95,9.89-.78,2.02c-.25.65-.88,1.08-1.58,1.06-.39-.03-.77-.12-1.13-.27v1.77c.43.15.89.22,1.34.21,1.71,0,2.5-.85,3.39-3.12l5.04-13.28h-2.03Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.86,6.56l1.27,1.33s.11.13.19.23c.39.46.9,1.27.88,2.43-.02,1.68-1.07,2.67-1.07,2.67l-14.8,14.74-1.39-1.42s-.35-.37-.61-1c-.13-.3-.33-.9-.27-1.84.09-1.46,1.28-2.67,1.28-2.67l14.52-14.48h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.67,0L15.42,19.19s-1.24,1.32-1.83,2.54c-.94,1.94-.33,4.93,1.1,6.33.81.79,1.49,1.43,1.49,1.43,0,0,.51.41,1.34.41s1.45-.82,1.45-.82l13.77-13.71s.88-.69,1.4-2.03c.52-1.35.39-2.97.39-2.97l2.28,2.38s1.45,1.27,1.42,3.26c-.04,2.1-1.64,3.36-1.64,3.36l-14.15,14.11s-1.52,1.28-3.23.98c-1.39-.24-2.02-.98-2.02-.98l-8.29-8.25s-1.45-1.35-1.35-3.73c.09-2.3,1.33-3.38,1.33-3.38L27.04,0h7.63Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.51,0h7.76L7.07,17.14s-2.21,2.59-1.28,6.56c.48,2.08,2.13,3.45,2.13,3.45l7.79,7.61s1.53,2.06,5.17,1.51c1.64-.25,2.65-1.3,2.65-1.3l13.67-13.63s1.64-1.53,1.98-3.47c.21-1.21.13-2.53.13-2.53l1.84,1.92s1.43,1.55,1.48,3.85c.06,2.37-1.49,4.02-1.49,4.02l-15.11,15.05s-1.71,1.98-4.73,1.85c-2.48-.11-4.01-1.82-4.01-1.82L2.19,25.19S-.48,22.82.08,18.57c.35-2.67,2.29-4.48,2.29-4.48L16.51,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcasLogo);
export default __webpack_public_path__ + "static/media/calcas-logo.9419f8e6f6b7adf9cc0c253aba76c3d5.svg";
export { ForwardRef as ReactComponent };